export default __webpack_public_path__ + "static/Pokitpal-Case-Study-AWS-6c72c1d804ef2ba5b20a4518d90e251f.pdf";